import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './TagsList.module.css';
import { Tag } from '../../../../shared/ui';

interface TagsListProps {
    tags: string[];
    classes?: string;
}

export const TagsList = memo(({ classes, tags }: TagsListProps) => {
    return (
        <div className={cls.TagsList_Wrapper}>
            {/*<span className={cls.IconWrapper}>*/}
            {/*    <Icon iconName={'taskTags'} />*/}
            {/*</span>*/}
            <ul className={classNames(cls.TagsList, [classes])}>
                {tags.map((tag, i) => (
                    <Tag tagName={tag} key={i} />
                ))}
            </ul>
        </div>
    );
});
